import {makeStyles} from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  EditProfileContentContainer: {
    height: '100%',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  EditProfileContent: {
    height: '100%',
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2, 3)
  }
}))
